import React, { useEffect, useState } from "react";

import {
  getColorAndSize,
  getButton,
  isSelectedVariantOutOfStock,
} from "../../helpers/common";

import { useDispatch, useSelector } from "react-redux";
import { removeItem, editQty } from "../../redux/cartReducer";

import { Link } from "react-router-dom";

import "./CartCard.scss";
import { ReactComponent as UAEDirham } from "../../SVGs/UAEDirham.svg";
import { ReactComponent as Minus } from "../../SVGs/Minus.svg";
import { ReactComponent as Addition } from "../../SVGs/Addition.svg";
import { ReactComponent as Delete } from "../../SVGs/Delete.svg";

import { useTranslation } from "react-i18next";

const CartCard = ({ product, inCheckout = false }) => {
  const [productBarcode, setProductBarcode] = useState("");
  const [productQty, setProductQty] = useState(0);
  const [colorValue, setColorValue] = useState("");
  const [sizeValue, setSizeValue] = useState("");
  const [buttonValue, setButtonValue] = useState("");

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const dispatch = useDispatch();
  const productsIds = useSelector((state) => state.cart.products);

  const deleteProduct = () => {
    dispatch(removeItem({ barcode: productBarcode, selectedButtonId: product?.selectedButtonId }));
  };

  const subtractQty = () => {
    dispatch(
      editQty({
        barcode: productBarcode,
        selectedButtonId: product?.selectedButtonId,
        operation: "-",
      })
    );
  };

  const addQty = () => {
    const selectedVariant = product?.product?.attributes?.Variants?.find(
      (variant) => variant?.id == product?.selectedVariantId
    );
    if (selectedVariant) {
      const selectedSize = selectedVariant?.Sizes?.find(
        (size) => size?.Barcode == product?.barcode
      );
      if (selectedSize) {
        const totalQtyForBarcode = productsIds
          .filter((item) => item?.barcode === product?.barcode)
          .reduce((sum, item) => sum + (item?.quantity || 0), 0);
        if (selectedSize?.Quantity >= totalQtyForBarcode + 1) {
          dispatch(
            editQty({
              barcode: productBarcode,
              selectedButtonId: product?.selectedButtonId,
              operation: "+",
            })
          );
        }
      } else {
        dispatch(removeItem(productBarcode));
      }
    } else {
      dispatch(removeItem(productBarcode));
    }
  };

  const getProductTitle = (prod) => {
    let prodName = prod?.attributes?.Title;
    if (currentLanguage != "en") {
      const localization = prod?.attributes?.localizations?.data?.find(
        (locale) => locale?.attributes?.locale === currentLanguage
      );
      if (localization) {
        prodName = localization?.attributes?.Title;
      }
    }

    return prodName;
  };

  const stateProduct = productsIds.find(
    (item) => item?.barcode === product?.barcode &&
            item?.selectedButtonId === product?.selectedButtonId
  );
  useEffect(() => {
    if (stateProduct) {
      setProductBarcode(stateProduct.barcode);
      setProductQty(stateProduct.quantity);
    }
  }, [stateProduct]);

  useEffect(() => {
    const isOutOfStock = isSelectedVariantOutOfStock(
      product?.product,
      product?.barcode,
      product?.selectedVariantId
    );
    if (isOutOfStock) {
      dispatch(removeItem(product?.barcode));
    }
    const [color, size] = getColorAndSize(
      product?.product,
      product?.barcode,
      product?.selectedVariantId,
      currentLanguage
    );
    const button = getButton(product?.product, product?.selectedButtonId, product?.selectedVariantId, currentLanguage);
    if (!color || !size) {
      dispatch(removeItem(product?.barcode));
    }
    setColorValue(color);
    setSizeValue(size);
    setButtonValue(button);
  }, [product]);

  if (!stateProduct) return null;

  return (
    <div className="cart-card">
      <div className="image">
        <img
          className="img"
          src={`${
            process.env.REACT_APP_IMAGE_URL +
            product?.product?.attributes?.DefaultImage?.data?.attributes?.url
          }`}
          alt={
            product?.product?.attributes?.DefaultImage?.data?.attributes
              ?.alternativeText
          }
        />
        <div className="product-quantity">
          <span>{inCheckout ? product?.qty : productQty}</span>
        </div>
      </div>
      <div className="info">
        <Link
          to={`/product/${product?.product?.attributes?.SEOURL}`}
          className="cart-card-title"
        >
          {getProductTitle(product?.product)}
        </Link>
        <h3 className="cart-card-barcode">
          {t("home.barcode")}: <span>{productBarcode}</span>
        </h3>
        <h3 className="cart-card-options">
          {t("home.color")}: <span>{colorValue}</span>, {t("home.size")}:{" "}
          <span>{sizeValue}</span>
          {buttonValue && <>, {t("home.button")}: <span>{buttonValue}</span></>}
        </h3>
        <div className="price">
          {product?.product?.attributes?.discountedPrice != null &&
          parseFloat(product?.product?.attributes?.discountedPrice) <
            parseFloat(product?.product?.attributes?.Price) ? (
            <div className="real-price">
              <div className="price-container">
                <span className="currency">
                  <UAEDirham />
                </span>
                <span className="numerical-price">
                  {product?.product?.attributes?.Price}
                </span>
              </div>
              <span className="vat">{t("home.price-with-vat")}</span>
            </div>
          ) : (
            <></>
          )}
          <div className="discounted-price">
            <div className="price-container">
              <span className="currency">
                <UAEDirham />
              </span>
              <span className="numerical-price">
                {product?.product?.attributes?.discountedPrice ??
                  product?.product?.attributes?.Price}
              </span>
            </div>
            <span className="vat">{t("home.price-with-vat")}</span>
          </div>
        </div>
        {!inCheckout ? (
          <>
            <div className="quantity">
              <span className="minus" onClick={subtractQty}>
                <Minus />
              </span>
              <span className="qty">{productQty}</span>
              <span className="addition" onClick={addQty}>
                <Addition />
              </span>
            </div>
            <Delete className="delete-btn" onClick={deleteProduct} />
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default CartCard;
